$ ->
  return unless $('body').is('.content-structure')

  # FIXME: This is going to add 'content-text-link-clicked' regardless of whether the link was clicked or not
  $('.content-structure-text a').attr("data-tracking-action", 'content-text-link-clicked')
